import axiosInstance from './axios';
import backendUrl from '../backendUrl';
import { token } from './auth';

const baseUrl = `${backendUrl}/api/store`;

const setConfig = () => ({
  headers: { 'x-auth-token': token },
});

/**
 * The catalog is the full item list decorated with per-user ownership, not two
 * lists to zip together client-side. It is readable signed out (everything
 * comes back `owned: false`), which is what lets the store act as a shop window.
 */
const getCatalog = async (): Promise<any[]> => {
  const response = await axiosInstance.get(`${baseUrl}/catalog`, setConfig());
  return response.data;
};

const getInventory = async (): Promise<any[]> => {
  const response = await axiosInstance.get(`${baseUrl}/inventory`, setConfig());
  return response.data;
};

/**
 * Buy an item. The idempotency key is what makes a double-tap on a slow
 * connection charge once: a retry returns the original purchase rather than
 * debiting again.
 */
const purchase = async (itemKey: string, idempotencyKey: string): Promise<any> => {
  const response = await axiosInstance.post(
    `${baseUrl}/purchases`,
    { itemKey },
    { headers: { ...setConfig().headers, 'Idempotency-Key': idempotencyKey } }
  );
  return response.data;
};

/** Equip an owned item, or pass null to clear the slot. */
const equip = async (slot: string, itemKey: string | null): Promise<any> => {
  const response = await axiosInstance.put(`${baseUrl}/equipped`, { slot, itemKey }, setConfig());
  return response.data;
};

const updatePreferences = async (seasonalOptOut: boolean): Promise<any> => {
  const response = await axiosInstance.patch(`${baseUrl}/preferences`, { seasonalOptOut }, setConfig());
  return response.data;
};

const storeService = {
  getCatalog,
  getInventory,
  purchase,
  equip,
  updatePreferences,
};

export default storeService;
